import React from 'react';
import './BreadCrumbsComponent.scss';
import { useNavigate } from 'react-router-dom';
import {
  CoreBreadcrumb,
  CoreBreadcrumbItem,
} from '@komodo-design-system/komodo-components-react';
import { serviceUrl } from 'api/config';

// Define the type for breadcrumb data
interface BreadCrumbItem {
  label: string;
  path: string;
}

// Define the props for the component
interface BreadCrumbsComponentProps {
  breadCrumbData: BreadCrumbItem[];
}

const BreadCrumbsComponent: React.FC<BreadCrumbsComponentProps> = ({
  breadCrumbData,
}) => {
  const navigate = useNavigate();

  // Handle breadcrumb click
  const onBreadCrumbClick = (value: string) => {
    if( value === '/store/admin') {
      window.location.href =
        (serviceUrl?.includes('localhost') || serviceUrl?.includes('qa'))
          ? 'https://qa1-customercare.thermofisher.com/store/admin'
          : 'https://customercare.thermofisher.com/store/admin';
      return;
    }
    navigate(value);
  };

  // Render breadcrumb content
  const content = (label: string, value: string) => {
    return <div onClick={() => onBreadCrumbClick(value)}>{label}</div>;
  };

  // Generate breadcrumb items
  const breadCrumbItemsList = () => {
    return breadCrumbData.map(({ label, path }, idx) => {
      return (
        <CoreBreadcrumbItem
          divider="&#8250;"
          key={`${path}-${label}-${idx}`} // Ensure uniqueness
          lastitem={false}
          data-testid={label}
        >
          <div slot="content">{content(label, path)}</div>
        </CoreBreadcrumbItem>
      );
    });
  };

  return (
    <div className="sc-breadcrumbContainer" data-testid="breadcrumb-container">
      <CoreBreadcrumb>{breadCrumbItemsList()}</CoreBreadcrumb>
    </div>
  );
};

export default BreadCrumbsComponent;